import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";

import { ATTACH_POLICY_TO_INTENT_PROJECT } from "./gql";

const useAttachPolicyMutation = createDefaultMutationHook(ATTACH_POLICY_TO_INTENT_PROJECT);

const useAttachPolicyToIntentProject = (refetchQueries?: string[]) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [attachPolicy, { loading }] = useAttachPolicyMutation({
    refetchQueries,
  });

  const handleAttachPolicy = useCallback(
    (policyId: string, intentProjectId: string, successCallback?: () => void) => {
      attachPolicy({ id: policyId, intentProject: intentProjectId }, (data) => {
        if (data?.policyIntentProjectAttach) {
          reportSuccess({
            message: "Policy was successfully attached",
          });
          successCallback?.();
        }
      });
    },
    [attachPolicy, reportSuccess]
  );

  return {
    attachPolicy: handleAttachPolicy,
    loading,
  };
};

export default useAttachPolicyToIntentProject;
